import { useEffect, useState } from "react";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { DesfaseRelojApi } from "../api/DesfaseRelojApi";
import { getErrorFromResponse } from "../../../../../utility/utils";

// Fecha y hora con desfase de un reloj. No sale de la hora del navegador: se
// guarda la diferencia entre la que entregó el servidor y la del navegador en
// ese momento, y se suma cada vez que se consulta
export const useFechaHoraReloj = (contexto) => {
    const { getRelojVigente, cargando } = DesfaseRelojApi();

    const [estado, setEstado] = useState(null);
    const [diferenciaMs, setDiferenciaMs] = useState(0);

    // se marca al terminar la consulta aunque falle: sin respuesta se sigue la
    // hora actual, y el backend valida de todas formas
    const [cargado, setCargado] = useState(false);

    const ActualizarEstado = (response) => {
        setEstado(response);
        setDiferenciaMs(
            moment(response.fecha_hora_con_desfase).diff(moment()),
        );
    };

    const CargarReloj = async () => {
        try {
            const response = await getRelojVigente(contexto);
            ActualizarEstado(response);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener la fecha y hora del reloj",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        } finally {
            setCargado(true);
        }
    };

    useEffect(() => {
        CargarReloj();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contexto]);

    const obtenerFechaHora = () => moment().add(diferenciaMs, "ms");

    // mientras responde el servidor se asume tiempo actual
    const esTiempoActual = estado ? estado.es_tiempo_actual : true;

    // el reloj se configura después del correlativo inicial de pallets; hasta
    // saberlo no se muestra
    const correlativoConfigurado = estado
        ? estado.correlativo_inicial_configurado
        : false;

    // fecha y hora de corte del último cierre de inventario de bodega, para
    // advertir cuando el reloj se lleva a una fecha que ese cierre ya congeló
    const fechaUltimoCierreBodega = estado
        ? estado.fecha_ultimo_cierre_bodega
        : null;

    return {
        diferenciaMs,
        esTiempoActual,
        correlativoConfigurado,
        fechaUltimoCierreBodega,
        cargado,
        obtenerFechaHora,
        ActualizarEstado,

        cargando,
    };
};
